<div class="body ui container" fxLayout="column">
  <div fxLayout="row" fxLayoutAlign="space-between center" class="top">
    <div>
      <span>Home</span>
      <h2 class="ui primary header">Create an Account</h2>
    </div>
  </div>
  <div class="ui divider" appMargin marginY="3"></div>

  <div fxLayout="row" fxLayout.lt-sm="column" fxLayoutGap="30px">
    <div fxFlex="grow">
      <div
        class="ui padded segment text-left no-border"
        fxLayout="column"
        appPadding="10"
        id="bg-color"
      >
        <div appMargin marginB="10">Company details you provided</div>

        <div
          fxFlex
          fxLayout="row"
          fxLayoutAlign="space-between start"
          appMargin
          marginB="10"
        >
          <div fxFlex>
            <div class="sub-label">COMPANY OWNERSHIP TYPE</div>
            <div class="sub-value">Nigerian Owned</div>
          </div>

          <div fxFlex>
            <div class="sub-label">COMPANY TYPE</div>
            <div class="sub-value">Private Company Limited by Shares</div>
          </div>
        </div>

        <div fxFlex fxLayout="row" fxLayoutAlign="space-between start">
          <div fxFlex>
            <div class="sub-label">COMAPNY RC/BN NUMBER</div>
            <div class="sub-value">861455</div>
          </div>

          <div fxFlex>
            <div class="sub-label">COMPANY TAX IDENTIFICATION NUMBER (TIN)</div>
            <div class="sub-value">05065899-0001</div>
          </div>
        </div>
      </div>

      <div
        class="ui segment no-border alert"
        fxLayout="row"
        fxLaoutAlign="space-between center"
      >
        <div fxFlex="7%">
          <i class="exclamation triangle big colored primary icon"></i>
        </div>

        <div fxFlex>
          You are allowed a maximum of <strong>3 attempts.</strong> You have
          <strong>2 out of 3</strong> attempts left. If you are unable to
          proceed with your registration,
          <strong id="primary">click here</strong> to send us a message.
        </div>
      </div>

      <div appMargin marginB="10">Please verify your company name below</div>

      <div appMargin marginB="10">
        Is the name of your company
        <strong>“ENCENTRAL SOLUTIONS LIMITED”?</strong>
      </div>

      <div class="ui form">
        <div class="field">
          <div class="ui radio checkbox checked">
            <input
              type="radio"
              name="list"
              checked=""
              tabindex="0"
              class="hidden"
            />
            <label>Yes</label>
          </div>
        </div>

        <div class="field">
          <div class="ui radio checkbox">
            <input type="radio" name="list" tabindex="0" class="hidden" />
            <label>No</label>
          </div>
        </div>

        <div class="required field">
          <label for="">Please enter the correct company name below</label>
          <input type="text" name="" placeholder="ENCENTRAL SOLUTIONS" />
        </div>
      </div>

      <div
        class="ui box segment"
        fxLayout="row"
        fxLayoutAlign="space-between center"
        id="section"
      >
        <div fxFlex routerLink="/home-page/sign-up/step3" class="link">
          <i class="arrow left colored primary icon"></i>
        </div>
        <div>
          <button
            class="ui primary button"
            routerLink="/home-page/sign-up/step5"
          >
            Proceed
          </button>
        </div>
      </div>
    </div>

    <div
      fxFlex="30%"
      fxFlex.lt-sm="100%"
      appPadding
      paddingT="0"
      fxLayout="column"
      class="ui vertical basic segment"
      [ngClass]="{ loading: mpending }"
    >
      <div class="side" appPadding="7">
        <div [innerHtml]="registrationSidebar"></div>
      </div>
    </div>
  </div>
</div>
